import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Modal from '../Modal/Modal';
import DyCollectionCard from '../DyCollectionCard/DyCollectionCard';
import AddToCartBtn from '../AddToCartBtn/AddToCartBtn';
import Image from '../Image';

import useDyRecommendationWidgetData from '../../hooks/useDyRecommendationWidget';
import ProductDetails from '../ProductDetails/ProductDetails';
import { useQuery } from '@apollo/react-hooks';
import { queryProductByHandle } from '../../Queries';

import { StyledH5, StyleFlexRow, StyledImageWrapper, StyledDetailsWrapper } from './ProductAddOnListModalStyles';

var ProductAddOnListModal = function ProductAddOnListModal(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      modalActive = _useState2[0],
      setModalActive = _useState2[1];

  useEffect(function () {
    if (props.addOnClicked === true) {
      setModalActive(true);
    }
  }, [props.addOnClicked]);

  var _useQuery = useQuery(queryProductByHandle, {
    variables: { handle: props.productHandle }
  }),
      loading = _useQuery.loading,
      error = _useQuery.error,
      data = _useQuery.data;

  if (error) throw new Error(error);

  var handleCloseModal = function handleCloseModal() {
    setModalActive(false);
    // Set product handle in parent to default state
    props.setProductHandleForModal('');
  };

  var getCroppedImage = function getCroppedImage(image_url) {
    return image_url.replace('1000x1000', '600x600');
  };

  var product = data.productByHandle;
  if (!loading && modalActive) {
    return React.createElement(
      Modal,
      {
        className: 'ProductAddOnModal',
        active: modalActive,
        closeModalFunc: handleCloseModal,
        modalHeight: '500px',
        modalWidth: '700px'
      },
      React.createElement(
        StyledH5,
        null,
        product.title
      ),
      React.createElement(
        StyleFlexRow,
        null,
        React.createElement(
          StyledImageWrapper,
          null,
          React.createElement('img', {
            src: getCroppedImage(product.images.edges[0].node.productImg),
            alt: product.title
          })
        ),
        React.createElement(
          StyledDetailsWrapper,
          null,
          React.createElement(ProductDetails, {
            whyWeLove: product.whyWeLove,
            care: product.care,
            careLongText: product.careLongText,
            expertTips: product.expertTips,
            material: props.selected.variant.material,
            dimension: props.selected.variant.dimension
          })
        )
      )
    );
  } else {
    return null;
  }
};

ProductAddOnListModal.propTypes = {
  addOnClicked: PropTypes.bool.isRequired,
  productHandle: PropTypes.string.isRequired,
  setProductHandleForModal: PropTypes.func.isRequired,
  selected: PropTypes.object
};

export default ProductAddOnListModal;